(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  let toastTimer;
  const format = (value, currency) => new Intl.NumberFormat('ro-RO', {style:'currency', currency:currency || 'RON'}).format(value / 100);
  function paint(cart) {
    document.querySelectorAll('[data-bst-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelectorAll('[data-bst-total]').forEach(el => el.textContent = format(cart.total_price,cart.currency));
  }
  async function refresh() {
    try { const r = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}}); if(r.ok) paint(await r.json()); } catch (_) { /* Existing cart remains available via its native page. */ }
  }
  function notify(message) {
    const box = document.querySelector('.bst-toast');
    if (!box) return;
    clearTimeout(toastTimer); box.textContent = message; box.hidden = false;
    toastTimer = setTimeout(() => { box.hidden = true; }, 2800);
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.bst-add-form')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const quantity = Number(form.elements.quantity.value);
    if (!Number.isInteger(quantity) || quantity < 1) return;
    const button = form.querySelector('button');
    const error = form.closest('.bst-card').querySelector('.bst-card-error');
    const originalLabel = button.textContent;
    error.hidden = true; form.dataset.busy = 'true'; button.disabled = true; button.textContent = 'Se adauga...';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:form.elements.id.value,quantity}]})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Produsul nu a putut fi adaugat.');
      await refresh();
      notify(quantity + ' buc. adaugate in cos');
    } catch (e) {
      error.textContent = e.message === 'Failed to fetch' ? 'Conexiune intrerupta. Verifica mai intai cosul inainte de a reincerca.' : e.message;
      error.hidden = false;
    } finally { delete form.dataset.busy; button.disabled = false; button.textContent = originalLabel; }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('cart:update', refresh);
  setInterval(() => { if (!document.hidden) refresh(); }, 15000);
})();
